import React, { Component } from 'react';
import { connect } from 'react-redux';
import CoRenterAdd from './CoRenterAdd';
import CoRenterForm from './CoRenterForm';
import RenterAdd from './RenterAdd';
import RenterForm from './RenterForm';
import {
  copyRenterBasic,
} from '../../duck/coRenter';
import {
  Button,
  Modal,
  Step,
} from 'semantic-ui-react';
import { Warning } from '../../components';

class Renter extends Component {
  state = {
    activeItem: 'renter',
    // addOpen: false,
  }

  setActiveItem = (activeItem) => this.setState({ activeItem })

  // toggleAddOpen = (e) => {
  //   e ? e.preventDefault() : null

  //   this.setState({ addOpen: !this.state.addOpen });
  // }

  render() {
    const { activeItem } = this.state;
    const {
      coRenter,
      renter,
    } = this.props;

    if (!renter.id) {
      return (
        <RenterAdd />
      )
    }

    let steps = [
      {
        key: 'renter',
        icon: 'user',
        title: 'Renter',
        description: renter.first_name && renter.last_name ? `${renter.first_name} ${renter.last_name}` : '',
        onClick: () => this.setActiveItem('renter'),
        active: activeItem == 'renter',
      },
    ];

    if (coRenter) {
      steps.push({
        key: 'coRenter',
        icon: 'user outline',
        title: 'Co-Renter',
        active: activeItem == 'coRenter',
        description: coRenter.first_name && coRenter.last_name ? `${coRenter.first_name} ${coRenter.last_name}` : '',
        onClick: () => this.setActiveItem('coRenter'),
      })
    } else {
      steps.push({
        key: 'coRenter',
        icon: 'add user',
        title: 'Add Co-Renter',
        //onClick: () => this.toggleAddOpen(),
        onClick: () => this.setActiveItem('coRenter'),
      })
    }

    if (this.state.addOpen) {
      return (
        <div>
          <CoRenterForm
            add={true}
            renter={this.props.renter}
            toggleForm={this.toggleAddOpen}
          />
        </div>
      );
    }

    return (
      <div>
        <Step.Group
          items={steps}
          fluid
          size="tiny"
        />
        {
          activeItem == 'renter' &&
            <RenterForm />
        }
        {
          activeItem == 'coRenter' && !coRenter &&
            <CoRenterAdd />
        }
        {
          activeItem == 'coRenter' && coRenter &&
            <CoRenterForm />
        }
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    dealer: state.dealer,
    renter: state.renter,
    coRenter: state.coRenter,
  }
}

export default connect(mapStateToProps)(Renter);
